export default class LazyVideo {
  constructor(el) {
    this.el = el

    this.setVars()
    this.bindEvents()
  }

  setVars() {
    this.video = this.el.querySelector('iframe')
    this.videoSrc = this.video.getAttribute('data-src')
    this.poster = this.el.querySelector('[data-video-poster]')
    this.playBtn = this.el.querySelector('[data-video-play]')
  }

  bindEvents() {
    this.playBtn.addEventListener('click', this.playVideo.bind(this))
  }

  playVideo() {
    this.poster.classList.add('opacity-0')
    this.poster.classList.add('invisible')
    this.video.removeAttribute('tabindex')
    this.loadVideo()
    this.video.focus()
  }

  loadVideo() {
    this.video.setAttribute('src', this.videoSrc)
  }
}
